import { IdentityRepository } from '@domain/models/identity/gateway/identity-repository';

export class FullLogoutUseCase {
  constructor(private readonly _identityRepository: IdentityRepository) {}
  execute(fullUrlLogout: string): void {
    this._identityRepository.fullLogout(fullUrlLogout);
  }
}
